import React, {useState, useEffect} from 'react';
import UserService from '../../Services/user.service';
import WeekService from '../../Services/week.service';
import './insertweek.css';

const Insertweek=()=>{

    const [usercode, setusercode]=useState(0);
    const [useryear, setuseryear]=useState(new Date(Date.now()).getFullYear());
    const [userweek, setuserweek]=useState(0);
    const [weekday1, setweekday1]=useState("");
    const [weekday2, setweekday2]=useState("");
    const [weekday3, setweekday3]=useState("");
    const [weekday4, setweekday4]=useState("");
    const [weekday5, setweekday5]=useState("");
    const [weekday6, setweekday6]=useState("");
    const [weekday7, setweekday7]=useState("");

    const [successful, setsuccessful]= useState(false);
    const [message, setmessage]= useState("");
 
    const inserisci=()=>{
        console.log(usercode+useryear+userweek);
        console.log(weekday1+weekday2+weekday3+weekday4+weekday5+weekday6+weekday7)
    }

    const [allusers, setAllusers]=useState("");

    useEffect(() => {
        UserService.getAllUsers().then(
          (response) => {
            setAllusers(response.data);
          },
          (error) => {
            const _content =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
    
            setAllusers(_content);
          }
        );
      }, []);

      var names=[];
      var codenames=[];

      for(var i=0;i<allusers.length;i++)
      {
        names.push(allusers[i].firstname);
        codenames.push(allusers[i].usercode);
      }

    var list = [];
    for (var i = 1; i <= 52; i++) {
        if(i<10)
        {
        i='0'+i;
        }
        list.push(<option value={i.toString()}>{i.toString()}</option>);
    }
    ///inserisco gli utenti nella dropdownlist
    var arraynomi = names.toString().split(",").map(String);
    var arraycodenomi = codenames.toString().split(",").map(String);
    //console.log(arraynomi[1])

    var utentis=[];
    for (var u = 0; u < arraynomi.length; u++) {
        utentis.push(<option value={arraycodenomi[u]}>{arraynomi[u].toString()}</option>);
    }

    const handleRegister=(e)=>{
        e.preventDefault();

        setmessage("");
        setsuccessful(false);

        WeekService.registerweek(usercode, useryear, userweek, weekday1, weekday2, weekday3, weekday4, weekday5, weekday6, weekday7)
        .then(
            res => {
                setmessage(res.data.message);
                setsuccessful(true);
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
    
                setsuccessful(false);
                setmessage(resMessage);
                
            }
          );
    }

    return(
        <div>
            <form onSubmit={handleRegister}>
                <div className='row'>
                    <select key={'a10'} className='dropdownlist col-lg-2' type="text" name='Utente' defaultValue={'00'} onChange={e => setusercode(e.target.value)}>
                        <option value={'00'} disabled>Utente</option>
                        {utentis}
                    </select>
                    <select key={'a3'} className='dropdownlist col-lg-1' type="text" name='setti' defaultValue={'00'} onChange={e => setuserweek(e.target.value)}>
                        <option value="00" disabled>Settimana</option>
                        {list}
                    </select>
                    <div className='w-100'></div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Lunedì: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday1(e.target.value)}></textarea>
                    </div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Martedì: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday2(e.target.value)}></textarea>
                    </div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Mercoledì: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday3(e.target.value)}></textarea>
                    </div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Giovedì: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday4(e.target.value)}></textarea>
                    </div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Venerdì: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday5(e.target.value)}></textarea>
                    </div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Sabato: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday6(e.target.value)}></textarea>
                    </div>
                    <div className='col-lg-3'>
                        <label className='lbltit'>Domenica: </label>
                        <textarea className='textarea' onChange={(e)=>setweekday7(e.target.value)}></textarea>
                    </div>
                    <div className='col-xs-12 col-sm-12'>
                        <button id='butt' className='col-10' type="submit">Inserisci</button>
                    </div>
                </div>
            </form>
        </div>
    )
}
export default Insertweek;